import React, { FC, HTMLProps } from 'react';

import clsx from 'clsx';

import { useTranslate } from '@/hooks/use-translate';
import num2str from '@/utils/num2str';

import en from './en';

import './FishToBuyResultHeader.scss';

type Props = HTMLProps<HTMLDivElement> & {
	count: number;
	isNearWarehouses?: boolean;
};

export const FishToBuyResultHeader: FC<Props> = ({ count, isNearWarehouses, className }) => {
	const t = useTranslate(en);

	if (isNearWarehouses) {
		return (
			<div className={clsx('fish-buy-result-header', className)}>
				<p className="fish-buy-result-header__count">{t('Ближайшие предложения')}</p>
			</div>
		);
	}

	return (
		<div className={clsx('fish-buy-result-header', className)}>
			<p className="fish-buy-result-header__count">
				{`${count ?? 0} ${num2str(count, [
					t('предложение'),
					t('предложения'),
					t('предложений'),
				])}`}
			</p>
		</div>
	);
};
